export default __webpack_public_path__ + "static/media/ja2.6da1d8fe.jpg";